import * as Styled from './styled'
import { Props } from './interfaces'

function Card({ variant, borderColor, children, ...props }: Props) {
  return (
    <Styled.Card $variant={variant} $borderColor={borderColor} {...props}>
      {children}
    </Styled.Card>
  )
}

Card.defaultProps = {
  borderColor: 'neutral',
  variant: 'outlined',
  role: 'region',
}

export default Card
